import { moment } from '@utils/date';

const toCsvValue = (val: any) => {
  if (val === undefined || val === null) {
    return '';
  }

  const value = String(val)
    .replace(/\n/g, '')
    .replace(/"/g, '""');

  return `"${value}"`;
};

export const getResolveData = (
  unRsolveData: any[],
  skipFields: string[] = []
) => {
  const cols = {};

  return unRsolveData.map(el => {
    const newEl = {};
    for (const key in el) {
      if (!key.startsWith('_') && skipFields.indexOf(key) === -1) {
        if (!cols[key]) {
          const split = key.split('.');
          cols[key] = split[split.length - 1];
        }

        const newKey = cols[key];
        const fieldValue = el[key];

        if (fieldValue === null || fieldValue === undefined) {
          newEl[newKey] = '';
        } else if (Array.isArray(fieldValue)) {
          const length = fieldValue.length;
          newEl[`${newKey}_count`] = length;
          newEl[`${newKey}_last`] = toCsvValue(fieldValue[length - 1]);
        } else {
          if (newKey.endsWith('Date')) {
            const date = moment(fieldValue, moment.ISO_8601, true);
            newEl[newKey] = date.format('YYYY-MM-DD');
            newEl[newKey.replace('Date', 'Time')] = date.format('HH:mm');
          } else {
            newEl[newKey] = toCsvValue(fieldValue);
          }
        }
      }
    }

    return newEl;
  });
};
